import { render, staticRenderFns } from "./ConfiguracoesNotificacoes.vue?vue&type=template&id=0f1c3b77"
import script from "./ConfiguracoesNotificacoes.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesNotificacoes.vue?vue&type=style&index=0&id=0f1c3b77&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports